// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import decksReducer from './decksSlice';
import slidesReducer from './slidesSlice';
import userBusinessesReducer from './userBusinessesSlice';
import businessesReducer from './businessesSlice';
import usersReducer from './usersSlice';
import storeReducer from './storesSlice';

export const store = configureStore({
  reducer: {
    decks: decksReducer,
    slides: slidesReducer,
    userBusinesses: userBusinessesReducer,
    businesses: businessesReducer,
    users: usersReducer,
    stores: storeReducer,
  },
});
